<template>
  <transition name="compare-drawer">
    <aside
      v-if="compareCount && !comparePreviewOpen"
      class="compare-drawer"
      role="region"
      aria-label="Compare tasks"
    >
      <div class="compare-drawer__inner">
        <div class="compare-drawer__slots">
          <div
            v-for="(item, index) in displaySlots"
            :key="item ? item.compareEntryId : 'empty-' + index"
            class="compare-drawer__slot"
            :class="{ 'compare-drawer__slot--empty': !item }"
          >
            <template v-if="item">
              <button
                type="button"
                class="compare-drawer__slot-remove"
                aria-label="Remove from compare"
                @click="remove(item.compareEntryId)"
              >&times;</button>
              <div class="compare-drawer__slot-image" aria-hidden="true">
                <img
                  v-if="item.images && item.images.length"
                  :src="getImageUrl(item)"
                  :alt="item.title || ''"
                />
                <img
                  v-else
                  src="../../../assets/img/no-image-available.jpg"
                  alt=""
                />
              </div>
              <p class="compare-drawer__slot-title">{{ item.title }}</p>
            </template>
            <p v-else class="compare-drawer__slot-placeholder">Select Task to compare</p>
          </div>
        </div>
        <div class="compare-drawer__actions">
          <button
            type="button"
            class="compare-drawer__compare"
            @click="openPreview"
          >
            Compare ({{ compareCount }}/3)
          </button>
          <button type="button" class="compare-drawer__clear" @click="clearAll">
            Clear all
          </button>
        </div>
      </div>
    </aside>
  </transition>
</template>

<script>
import { useCompare } from '../../../helpers/useCompare'

const SLOT_COUNT = 3

export default {
  name: 'CompareDrawer',
  watch: {
    compareCount: {
      immediate: true,
      handler: function (count) {
        document.body.classList.toggle('compare-drawer-visible', count > 0)
      }
    }
  },
  beforeUnmount: function () {
    document.body.classList.remove('compare-drawer-visible')
  },
  computed: {
    compareItems: function () {
      return this.$store.getters['compare/compareItems']
    },
    compareCount: function () {
      return this.compareItems.length
    },
    comparePreviewOpen: function () {
      return this.$store.getters['compare/comparePreviewOpen']
    },
    displaySlots: function () {
      const slots = []
      for (let i = 0; i < SLOT_COUNT; i++) {
        slots.push(this.compareItems[i] || null)
      }
      return slots
    }
  },
  methods: {
    remove: function (compareEntryId) {
      useCompare().removeFromCompare(compareEntryId)
    },
    clearAll: function () {
      useCompare().clearCompare()
    },
    openPreview: function () {
      useCompare().setComparePreviewOpen(true)
    }
  }
}
</script>
